<template>
  <div
    class="home"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-carousel trigger="click" height="5rem">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img class="banner-img" :src="getFileUrl(item.url)" />
        <!-- <img class="banner-img" :src="require('../assets/img/' + item)" /> -->
      </el-carousel-item>
    </el-carousel>
    <div class="data-statistics">
      <div>
        <div class="data-item-o">
          <img src="../assets/img/sjtj_1.svg" />
        </div>
        <div class="data-linetwo">
          <span class="num">{{ cumulativeShipmentVolume }}</span>
          <span class="txt">万吨</span>
        </div>
        <div class="data-linethree">
          <span class="txt">累计发货量</span>
        </div>
      </div>
      <div>
        <div class="data-item-e">
          <img src="../assets/img/bg_money.svg" />
        </div>
        <div class="data-linetwo">
          <span class="num">{{ cumulativeTransactionVolume }}</span>
          <span class="txt">万元</span>
        </div>
        <div class="data-linethree">
          <span class="txt">累计交易额</span>
        </div>
      </div>
      <div>
        <div class="data-item-o">
          <img src="../assets/img/sjtj_3.svg" />
        </div>
        <div class="data-linetwo">
          <span class="num">{{ cumulativeNumberOfVehicles }}</span>
          <span class="txt">辆</span>
        </div>
        <div class="data-linethree">
          <span class="txt">累计车次数</span>
        </div>
      </div>
      <div>
        <div class="data-item-e">
          <img src="../assets/img/sjtj_4.svg" />
        </div>
        <div class="data-linetwo">
          <span class="num">{{ numberOfTrainWaybillsToBeAllocated }}</span>
          <span class="txt">个</span>
        </div>
        <div class="data-linethree">
          <span class="txt">待配车运单数</span>
        </div>
      </div>
      <div>
        <div class="data-item-o">
          <img src="../assets/img/sjtj_5.svg" />
        </div>
        <div class="data-linetwo">
          <span class="num">{{ numberOfAuthenticatedUsers }}</span>
          <span class="txt">人</span>
        </div>
        <div class="data-linethree">
          <span class="txt">认证用户数</span>
        </div>
      </div>
    </div>
    <el-row
      :gutter="48"
      style="padding: 0.2rem 0.16rem 0.5rem 0.16rem; width: 100%"
    >
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12"
        style="margin-top: 10px"
      >
        <div style="width: 100%; height: 5rem; position: relative">
          <el-carousel trigger="click" height="5rem" indicator-position="none">
            <el-carousel-item v-for="(item, index) in video" :key="index">
              <img class="banner-img" :src="getFileUrl(item.url)" />
              <!-- <img class="banner-img" :src="require('../assets/img/' + item)" /> -->
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12"
        style="margin-top: 10px"
      >
        <div style="width: 100%; height: 5rem; position: relative">
          <div
            style="
              position: absolute;
              top: 0;
              right: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
            "
          >
            <div
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <div
                :class="[
                  activedNews === '102'
                    ? 'news-title actived-news'
                    : 'news-title'
                ]"
                @click="handleActivedNews('102')"
              >
                公司新闻
              </div>
              <!-- <div
                class="news-title"
                :class="[
                  activedNews === '103'
                    ? 'news-title actived-news'
                    : 'news-title'
                ]"
                @click="handleActivedNews('103')"
              >
                公示公告
              </div>
              <div
                class="news-title"
                :class="[
                  activedNews === '104'
                    ? 'news-title actived-news'
                    : 'news-title'
                ]"
                @click="handleActivedNews('104')"
              >
                行业新闻
              </div> -->
            </div>
            <div
              style="
                background: #ccc;
                width: 100%;
                height: 1px;
                border-radius: 2px;
                margin-top: 1px;
              "
            ></div>
            <div style="flex: 1; display: flex; flex-direction: column">
              <div
                v-for="item in homeNewsList"
                :key="item.id"
                class="news-content"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                  @click="jumpNewsDetail(item)"
                >
                  <div class="news-item">
                    {{ item.title }}
                  </div>
                  <div style="text-align: right">
                    {{ item.createTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="product-component">
      <h3 style="font-size: 26px; text-align: center; margin: 16px 0">荣誉</h3>
      <div class="show-product">
        <el-carousel
          trigger="click"
          class="my-carousel"
          arrow="always"
          :autoplay="false"
          indicator-position="none"
        >
          <el-carousel-item v-for="item in showProduct" :key="item.key">
            <div style="display: flex; width: 96%; margin-left: 2%">
              <div v-for="i in item.val" :key="i.url" class="carousel-wrap">
                <img :src="i.url" alt="home" @click="handleClickImg(i)" />
              </div>
            </div>
            <div style="display: flex; width: 96%; margin-left: 2%">
              <div
                v-for="i in item.val"
                :key="i.url"
                class="carousel-wrap-text"
              >
                <div
                  style="
                    background-color: #fff;
                    text-align: center;
                    line-height: 1;
                    width: 100%;
                    font-size: 16px;
                    font-weight: 500;
                    height: 35px;
                    line-height: 35px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ i.title }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- <ComponentProduct :imgUrl="item.url" :productName="item.name" /> -->
      </div>
    </div>
    <div class="partners-wrap">
      <h3 style="margin-bottom: 16px">合作伙伴</h3>
      <el-row :gutter="24">
        <el-col span="6" v-for="i in partnersList" :key="i.val">
          <img :src="i.val" alt="home" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  name: 'HelloWorld',
  components: {},
  data() {
    return {
      loading: false,
      video: [],
      activedNews: '102',
      homeNewsList: [],
      curActiveIndex: 1,
      allProduct: [],
      showProduct: [],
      titleArr: [],
      bannerList: [],
      companyName: '', //
      numberOrYear: '', //成立年限
      plantArea: '', //厂房面积
      floorSpace: '', //占地面积
      registeredCapital: '', //注册资本
      slogan: '秉承“诚信”、“务实”、“创新”、“进取”的企业精神', //企业文化
      newsList: [],
      allShowProduct: [],
      partnersList: [],
      cumulativeShipmentVolume: '',
      cumulativeTransactionVolume: '',
      cumulativeNumberOfVehicles: '',
      numberOfAuthenticatedUsers: '',
      numberOfTrainWaybillsToBeAllocated: ''
    };
  },
  mounted() {
    this.loading = true;
    http
      .post('/reception/homePage/getList', { groupType: '101' })
      .then(res => {
        // this.bannerList=res.data.filter((item)=>item.code==='banner').map((i)=>i.val)
        res.data.forEach(item => {
          if (item.code === 'companyName') {
            this.companyName = item.val;
          } else if (item.code === 'numberOrYear') {
            this.numberOrYear = item.val;
          } else if (item.code === 'plantArea') {
            this.plantArea = item.val;
          } else if (item.code === 'floorSpace') {
            this.floorSpace = item.val;
          } else if (item.code === 'registeredCapital') {
            this.registeredCapital = item.val;
          } else if (item.code === 'slogan') {
            this.slogan = item.val;
          } else if (item.code === 'banner') {
            this.bannerList.push({ name: item.code, url: item.val });
          } else if (item.code === 'shipin') {
            this.video.push({ name: item.code, url: item.val });
          }
        });
      })
      .finally(() => {
        this.loading = false;
      });
    this.getNews('102');
    http
      .post('/reception/about/getAllUs', {
        groupType: 113,
        pageNum: 1,
        pageSize: 5
      })
      .then(res => {
        this.allProduct = res.rows;
        this.carouselGrouping(res.rows);
      });
    http
      .post('/reception/homePage/getList', { groupType: '119' })
      .then(res => {
        this.partnersList = res.data || [];
      })
      .finally(() => {
        this.loading = false;
      });
    const formData = new FormData();
    formData.append('Authorization', '');
    http
      .post('/yocyoh/webapi/index/platformStatistics', formData, {
        'Content-Type': 'multipart/form-data'
      })
      .then(res => {
        this.cumulativeShipmentVolume = res.data.cumulativeShipmentVolume
          ? Math.round(Number(res.data.cumulativeShipmentVolume) / 10000000)
          : '';
        this.cumulativeTransactionVolume = res.data.cumulativeTransactionVolume
          ? Math.round(Number(res.data.cumulativeTransactionVolume) / 10000)
          : '';
        this.cumulativeNumberOfVehicles = res.data.cumulativeNumberOfVehicles
          ? Number(res.data.cumulativeNumberOfVehicles)
          : '';
        this.numberOfAuthenticatedUsers = res.data.numberOfAuthenticatedUsers
          ? Number(res.data.numberOfAuthenticatedUsers)
          : '';
        this.numberOfTrainWaybillsToBeAllocated = res.data
          .numberOfTrainWaybillsToBeAllocated
          ? Number(res.data.numberOfTrainWaybillsToBeAllocated)
          : '';
      });
  },
  computed: {},
  methods: {
    mouseover(item) {
      const obj = this.allProduct.find(a => a.code === item.code);
      let nameArr = [];
      let urlArr = [];
      if (obj) {
        nameArr = obj.name ? obj.name.split(',') : [];
        urlArr = obj.val ? obj.val.split(',') : [];
      }
      let imgArr = [];
      nameArr.forEach((n, index) => {
        imgArr.push({
          name: n,
          url: urlArr[index]
        });
      });
      this.carouselGrouping(imgArr);
    },
    mouseout() {
      this.carouselGrouping(this.allShowProduct);
    },
    carouselGrouping(data) {
      const num = Math.ceil(data.length / 4);
      let arr = [];
      for (let i = 0; i < num; i++) {
        arr.push({ key: i, val: data.slice(i * 4, i * 4 + 4) });
      }
      this.showProduct = arr;
    },
    getNews(type) {
      http
        .post('/reception/news/getNewsPage', {
          groupType: type,
          pageSize: 8,
          pageNum: 1
        })
        .then(res => {
          this.homeNewsList = res.rows;
        });
    },
    handleActivedNews(num) {
      this.activedNews = num;
      this.getNews(num);
    },
    getFileUrl(str) {
      const res = getFileUrl(str);
      return res;
    },
    handleClickImg(i) {
      // http
      //   .post('/reception/product/getProduct', {
      //     val: i.url
      //   })
      //   .then(res => {
      //     this.$router.push({
      //       path: `/showProduct/productDetail/${res.data.id}`
      //     });
      //   });
      // let titleCode = '';
      // let titleCode2 = '';
      // this.allProduct.forEach(p => {
      //   const valArr = p.val ? p.val.split(',') : [];
      //   const index = valArr.findIndex(val => val === i.url);
      //   if (index > -1) {
      //     titleCode = p.titleCode;
      //     titleCode2 = p.titleCode2.split(',')[index];
      //   }
      // });
      // this.$router.push({
      //   path: `/showProduct/${titleCode}?type=${titleCode2}`
      // });
    },
    toProduct(item) {
      const str = item.titleCode2.split(',')[0];
      this.$router.push({
        path: `/showProduct/${item.titleCode}?type=${str}`
      });
      // if (item.titleCode === 'electronicCeramics') {
      //   this.$router.push({
      //     path: `/showProduct/electronicCeramics?parentProductType=${item.titleCode}&type=${item.titleCode2}`
      //   });
      // } else {
      //   this.$router.push({
      //     path: `/showProduct/electromechanicalComponents?parentProductType=${item.titleCode}&type=${item.titleCode2}`
      //   });
      // }
    },
    underStandMore() {
      this.$router.push({ path: `/gywm/companyIntroduction` });
    },
    moreNews() {
      this.$router.push({ path: `/news/companyNews` });
    },
    jumpNewsDetail(item) {
      this.$router.push({ path: `/news/newsDetail/${item.id}` });
    },
    getEditorImg(str) {
      var data = [];
      str.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/,
        function (match, capture) {
          data.push(capture);
        }
      );
      return data;
    },
    convertIdeogramToNormalCharacter(val) {
      const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
      return val.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    getPlainTex(richCont) {
      let value = richCont;
      if (richCont) {
        // 方法一：
        value = value.replace(/\s*/g, ''); //去掉空格
        value = value.replace(/<[^>]+>/g, ''); //去掉所有的html标记
        value = value.replace(/↵/g, ''); //去掉所有的↵符号
        value = value.replace(/[\r\n]/g, ''); //去掉回车换行
        value = value.replace(/&nbsp;/g, ''); //去掉空格
        value = this.convertIdeogramToNormalCharacter(value);
        return value;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../variables.scss';
.partners-wrap {
  text-align: center;
  background: #fff;
  margin-top: 20px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  img {
    width: 100%;
    height: 150px;
  }
  h3 {
    font-size: 26px;
  }
}
.my-carousel {
  background: transparent;
  width: 100%;
  ::v-deep .el-carousel__container {
    height: 2.7rem;
  }
  ::v-deep .el-carousel__item {
    background-color: transparent !important;
  }
  ::v-deep .el-carousel__arrow--left {
    left: 0;
    top: 40%;
    background-color: #6e6e6e;
  }

  ::v-deep .el-carousel__arrow--right {
    right: 0;
    top: 40%;
    background-color: #6e6e6e;
  }
  @media screen and (max-width: 1000px) {
    ::v-deep .el-carousel__arrow--left {
      top: 20% !important;
    }
  }
  @media screen and (max-width: 1000px) {
    ::v-deep .el-carousel__arrow--right {
      top: 20% !important;
    }
  }
  .carousel-wrap-text {
    width: 20%;
    margin-left: 4%;
    //margin-top: 10px;
  }
  .carousel-wrap {
    width: 20%;
    padding-top: 2rem;
    margin-left: 4%;

    height: 0;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      // max-height: 240px;
      top: 0;
      left: 0;
      position: absolute;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
        transition: all 0.5s ease-out;
      }
    }
  }
}
.news-content {
  font-size: 16px;
  font-weight: 500;
  height: 12.5%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  // margin-top: 23px;
  .news-item {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    &:hover {
      color: #079de3;
    }
  }
}
.news-title {
  font-size: 16px;
  padding: 5px 80px;
  cursor: pointer;
  &:hover {
    background-color: $navBgColor;
    color: #fff;
  }
}
.actived-news {
  background-color: $navBgColor;
  color: #fff;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 0.14rem;
  opacity: 0.75;
  line-height: 1.5rem;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.banner-img {
  width: 100%;
  height: 5rem;
}
.size-style {
  display: flex;
  justify-content: center;
  margin-top: 0.8rem;
  li {
    width: 3rem;
    height: 1rem;
    align-self: center;
    border-right: 1px solid gray;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    p:nth-child(2) {
      margin-top: 0.1rem;
      font-size: 0.15rem;
      color: #999;
    }
  }
  li:nth-child(4) {
    border: none;
  }
}

// 组件样式部分
.product-component {
  box-sizing: border-box;
  padding: 0.2rem 0.16rem 0rem 0.16rem;
  width: 100%;
  background: #f4f4f4;
  p {
    color: #333;
    font-size: 0.33rem;
    font-weight: 300;
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .show-product {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img-container {
      display: flex;
      margin-left: 10px;
      margin-right: 10px;
      flex: 1;
      overflow: auto;
      justify-content: space-around;
      .home-img-wrap {
        cursor: pointer;
        img {
          object-fit: cover;
          width: 250px;
          height: 250px;
        }
        &:hover {
          img {
            transform: scale(1.1);
            transition: all 0.5s ease-out;
          }
        }
      }
    }
    i {
      font-size: 25px !important;
      background: rgba(51, 51, 51, 0.6980392156862745);
      padding: 5px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
    }
    .item-name {
      text-align: center;
      font-size: 0.2rem;
      margin-top: 0.1rem;
    }
  }
}
.more-news {
  width: 100%;
  height: 7rem;
  box-sizing: border-box;
  padding: 0.4rem 0rem 0rem 0rem;
  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    li {
      width: 4rem;
      height: 3.7rem;
      margin: 0.04rem;
      position: relative;
      img {
        width: 100%;
        height: 2.25rem;
        background: gray;
      }
      p {
        font-size: 0.2rem;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        margin-top: 0.1rem;
        height: 0.38rem;
        font-size: 0.15rem;
        line-height: 0.2rem;
        color: #999999;
        display: block;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      div {
        margin-top: 0.1rem;
        font-size: 0.15rem;
        background: none;
        outline: none;
        border: none;
        color: red;
      }
      .date-style {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: absolute;
        margin: 0rem;
        top: 0.05rem;
        left: 0.05rem;
        width: 0.8rem;
        height: 0.8rem;
        background: red;
        p {
          font-size: 0.14rem;
          color: #fff;
        }
        span {
          font-size: 0.2rem;
          color: #fff;
        }
      }
    }
  }
}
.data-statistics {
  width: 90%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-around;
}
.data-item-o {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 120px;
  background: url(../assets/img/bg_index_1.svg) no-repeat;
  background-size: cover;
  img {
    width: 70px;
    height: 70px;
  }
}
.data-item-e {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 120px;
  background: url(../assets/img/bg_index_2.svg) no-repeat;
  background-size: cover;
  img {
    width: 70px;
    height: 70px;
  }
}
.data-linetwo {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
}
.data-linethree {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
}
.num {
  font-size: 22px;
  color: $navBgColor;
}
.txt {
  font-size: 16px;
}
.sjtj-box {
  display: flex;
  margin-top: 1rem;
  justify-content: space-around;
}
.sjtj-cell {
  width: 20%;
  height: 3rem;
  text-align: center;
}
.sjtj-cell-l {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.98rem;
  height: 1.5rem;
  background: url(../assets/img/bg_index_1.svg) no-repeat;
}
.sjtj-cell-d {
  display: inline-block;
  width: 1.98rem;
  height: 1.5rem;
  background: url(../assets/img/bg_index_2.svg) no-repeat;
}
.sjtj-num-box {
  height: 0.3rem;
  line-height: 0.3rem;
}
</style>
